<template>
  <div v-if="!isMobile()">
    <div class="page-header clear-filter" filter-color="black2">
      <div
        style="
          width: 100%;
          height: 556px;
          background-color: #020520;
          position: absolute;
          left: 0px;
        "
      >
        <img
          src="/img/staking/main-img.png"
          width="1360px"
          height="556px"
          style="position: absolute; left: calc(50% - 680px); top: 0px"
        />
      </div>
      <div
        class="bg_bonus-area"
        v-bind:style="{ height: getTotalHeight() }"
      ></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <div class="LOKA-STAKING-POOLS">The Pledge of LOKA</div>
        <div class="LOKA-STAKING-POOLS-DESC">
          Empower your favorite continents by pledging your LOKA!<br />
          Gather forces to boost your continent and change the course of history!
        </div>
        <div
          style="
            position: absolute;
            left: calc(50% - 120px);
            top: 400px;
            width: 240px;
            height: 64px;
            border: solid 1px #fff;
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            letter-spacing: -0.18px;
            text-align: center;
            color: #fff;
            padding-top: 15px;
            cursor: pointer;
          "
          @click="clickLearnMore()"
        >
          Learn more
        </div>
      </div>
      <div
        style="
          position: absolute;
          top: 540px;
          height: 90px;
          width: 100%;
          border: solid 0 #000;
          background-color: #1b0c5b;
          text-align: center;
        "
      >
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 0 }"
          @click="clickMenu(0)"
        >
          Dashboard
          <div class="staking_tab_bar" v-if="menu == 0"></div>
        </div>
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 1 }"
          @click="clickMenu(1)"
        >
          The Pledge
          <div class="staking_tab_bar" v-if="menu == 1"></div>
        </div>
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 2 }"
          @click="clickMenu(2)"
        >
          My Pledge
          <div class="staking_tab_bar" v-if="menu == 2"></div>
        </div>
      </div>
      <div
        v-if="menu == 0"
        class="bg_staking_main"
        style="position: absolute; top: 1066px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${
            800 +
            104 * dashboard.continents.length * (1 - sub_menu) +
            104 * dashboard.individuals.length * sub_menu
          }px`,
        }"
      >
        <div
          style="
            position: absolute;
            top: -406px;
            font-family: Poppins;
            width: 100%;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #f3741f;
          "
        >
          * The pledged amount and the ranking per continent will be updated on
          UTC 00:00 everyday
        </div>
        <div
          style="
            width: 1440px;
            height: 370px;
            border: solid 0 #000;
            background-color: #2e334d;
            position: absolute;
            top: -370px;
            left: 0px;
          "
        >
          <div
            style="
              width: 1280px;
              height: 200px;
              border-radius: 16px;
              border: solid 0 #000;
              background-color: #fff;
              position: absolute;
              left: 80px;
              top: 70px;
            "
          >
            <div
              style="
                width: 120px;
                height: 120px;
                margin: 0 23px 0 0;
                padding-top: 26px;
                padding-left: 23px;
                border-radius: 40px;
                border: solid 0 #000;
                background-color: #e5eaf2;
                position: absolute;
                left: 40px;
                top: 40px;
              "
            >
              <img src="/img/icon-loka-copy-2.png" />
            </div>
            <div
              style="
                position: absolute;
                left: 185px;
                top: 60px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: -0.16px;
                text-align: left;
                color: #a5aaba;
              "
            >
              Total Pledged
            </div>
            <div
              style="
                position: absolute;
                left: 185px;
                top: 90px;
                font-family: Poppins;
                font-size: 40px;
                font-weight: bold;
                letter-spacing: -0.4px;
                text-align: left;
                color: #202431;
              "
            >
              {{ dashboard.totalValue.toFixed(2) | comma }}
              <span
                style="
                  font-family: Poppins;
                  margin-left: 10px;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                LOKA
              </span>
            </div>
            <div
              style="
                display:flex; align-items:center; justify-content:center;
                padding: 6px 0 0;
                width: 120px;
                height: 120px;
                margin: 0 23px 0 0;
                border-radius: 40px;
                border: solid 0 #000;
                background-color: #e5eaf2;
                position: absolute;
                left: 680px;
                top: 40px;
              "
            >
              <img src="/img/icon-user.png" />
            </div>
            <div
              style="
                position: absolute;
                left: 825px;
                top: 60px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: -0.16px;
                text-align: left;
                color: #a5aaba;
              "
            >
              Total Holder
            </div>
            <div
              style="
                position: absolute;
                left: 825px;
                top: 90px;
                font-family: Poppins;
                font-size: 40px;
                font-weight: bold;
                letter-spacing: -0.4px;
                text-align: left;
                color: #202431;
              "
            >
              {{ dashboard.totalHolder | comma }}
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: -24px;
            left: calc(50% - 292px);
            height: 48px;
            width: 584px;
            border-radius: 30px;
            border: solid 0 #000;
            background-color: #091033;
          "
        >
          <div
            class="staking_main_tab"
            v-bind:class="{ on: sub_menu == 0 }"
            @click="clickSubMenu(0)"
          >
            Continent
          </div>
          <div
            class="staking_main_tab"
            v-bind:class="{ on: sub_menu == 1 }"
            @click="clickSubMenu(1)"
          >
            Individual
          </div>
        </div>
        <div
          style="
            width: 100px;
            height: 40px;
            border-radius: 20px;
            border: solid 0 #000;
            background-color: #091033;
            position: absolute;
            right: 80px;
            top: -20px;
            cursor: pointer;
          "
          @click="clickTable()"
        >
          <div
            style="
              float: left;
              width: 28px;
              height: 28px;
              margin: 6px 6px 6px 6px;
              padding: 3px 12px;
              border-radius: 14px;
              border: solid 0 #000;
              background-color: #1b234e;
            "
          >
            <img src="/img/icon-info.png" />
          </div>
          <span
            style="
              float: left;
              margin-left: 5px;
              margin-top: 10px;
              font-family: Poppins;
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #fff;
            "
            >info</span
          >
        </div>
        <div v-if="sub_menu == 0">
          <div
            v-for="(continent, idx1) in [0, 1, 2]"
            :key="idx1"
            class="bg_card_staking_continent"
            style="position: absolute; top: 100px"
            v-bind:style="{ left: `${80 + 432 * idx1}px` }"
          >
            <div v-if="dashboard.continent.length > idx1">
              <div
                style="
                  width: 120px;
                  height: 120px;
                  border-radius: 40px;
                  border: solid 0 #000;
                  background-color: #e5eaf2;
                  position: absolute;
                  top: -20px;
                  left: 20px;
                  padding-left: 20px;
                  padding-top: 26px;
                "
              >
                <img src="/img/staking/icon-continent.png" />
              </div>
              <img
                v-bind:src="`/img/staking/label-tier-${dashboard.continent[idx1].tier}.png`"
                style="position: absolute; top: 0px; right: 20px"
              />
              <div
                style="
                  position: absolute;
                  left: 170px;
                  top: 24px;
                  font-family: Poppins;
                  font-size: 20px;
                  font-weight: 600;
                  letter-spacing: -0.2px;
                  text-align: left;
                  color: #202431;
                "
              >
                Continent {{ dashboard.continent[idx1].continent }}
              </div>
              <div
                style="
                  position: absolute;
                  left: 170px;
                  top: 58px;
                  width: 100px;
                  height: 32px;
                  border-radius: 6px;
                  border: solid 0 #000;
                  background-color: #0060ff;
                  text-align: left;
                  font-family: Poppins;
                  font-size: 14px;
                  font-weight: 500;
                  text-align: left;
                  color: #fff;
                  padding-top: 4px;
                  cursor: pointer;
                "
                @click="popContinentRank(dashboard.continent[idx1].continent)"
              >
                <img
                  src="/img/staking/icon-rank.png"
                  style="margin-left: 10px"
                />
                <span style="vertical-align: middle; margin-left: 10px"
                  >Rank</span
                >
              </div>
              <div
                style="
                  position: absolute;
                  left: 30px;
                  top: 129px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total Pledged
              </div>
              <div
                style="
                  position: absolute;
                  left: 32px;
                  top: 156px;
                  font-family: Poppins;
                  font-size: 40px;
                  font-weight: bold;
                  letter-spacing: -0.4px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ dashboard.continent[idx1].value.toFixed(2) | comma }}
              </div>
              <div
                style="
                  position: absolute;
                  right: 31px;
                  top: 165px;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
              <div
                style="
                  position: absolute;
                  left: calc(50% - 178px);
                  top: 227px;
                  width: 356px;
                  height: 1px;
                  opacity: 0.7;
                  border: solid 0 #000;
                  background-color: #c1c4d3;
                "
              ></div>
              <div
                style="
                  width: 356px;
                  height: 160px;
                  position: absolute;
                  left: 30px;
                  top: 248px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 1.81;
                  letter-spacing: -0.16px;
                  color: #202431;
                "
              >
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Resource Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[2] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Crystal Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[3] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Monster Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[4] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Medal Bonus
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[5] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    DSA Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[8] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Troops Buff
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[7] * 100) | comma }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg_staking_continent_list"
            style="position: absolute; left: calc(50% - 640px); top: 570px"
            v-bind:style="{
              height: `${153 + 104 * dashboard.continents.length}px`,
            }"
          >
            <div
              style="
                position: absolute;
                top: 0px;
                left: 30px;
                width: 1220px;
                height: 93px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                padding-top: 45px;
                color: #202431;
              "
            >
              <div style="width: 100px; float: left; height: 100%">Tier</div>
              <div style="width: 216px; float: left; height: 100%">
                Continent
              </div>
              <div style="width: 400px; float: left; height: 100%">
                Total Pleged
              </div>
              <div style="width: 504px; float: left; height: 100%">Effect</div>
              <div
                style="
                  width: 1220px;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
            <div
              v-for="(continent, idx2) in dashboard.continents"
              :key="idx2"
              style="position: absolute; left: 30px; width: 1220px"
              v-bind:style="{ top: `${93 + 104 * idx2}px` }"
            >
              <div
                style="
                  width: 100%;
                  height: 104px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: center;
                  color: #202431;
                "
              >
                <div
                  style="
                    width: 100px;
                    float: left;
                    height: 100%;
                    padding-top: 16px;
                  "
                >
                  <img
                    v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                  />
                </div>
                <div style="width: 216px; float: left; height: 100%">
                  <div
                    style="
                      margin-top: 16px;
                      font-family: Poppins;
                      font-size: 16px;
                      font-weight: 600;
                      letter-spacing: -0.2px;
                      color: #202431;
                    "
                  >
                    Continent {{ continent.continent }}
                  </div>
                  <div
                    style="
                      margin-left: calc(50% - 50px);
                      margin-top: 6px;
                      width: 100px;
                      height: 32px;
                      border-radius: 6px;
                      border: solid 0 #000;
                      background-color: #0060ff;
                      font-family: Poppins;
                      font-size: 14px;
                      font-weight: 500;
                      text-align: left;
                      color: #fff;
                      padding-top: 4px;
                      cursor: pointer;
                    "
                    @click="popContinentRank(continent.continent)"
                  >
                    <img
                      src="/img/staking/icon-rank.png"
                      style="margin-left: 10px"
                    />
                    <span style="vertical-align: middle; margin-left: 10px"
                      >Rank</span
                    >
                  </div>
                </div>
                <div
                  style="
                    padding-right: 100px;
                    width: 400px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    text-align: right;
                  "
                >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 24px;
                      font-weight: bold;
                      letter-spacing: -0.24px;
                      text-align: right;
                      color: #202431;
                    "
                    >{{ continent.value.toFixed(2) | comma }}</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 20px;
                      margin-left: 5px;
                      font-weight: 500;
                      letter-spacing: -0.2px;
                      text-align: right;
                      color: #a5aaba;
                    "
                    >LOKA</span
                  >
                </div>
                <div
                  style="
                    width: 504px;
                    float: left;
                    height: 100%;
                    padding-top: 10px;
                    padding-left: 50px;
                    padding-right: 50px;
                    font-family: Poppins;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.54;
                    letter-spacing: -0.13px;
                  "
                >
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Resource Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[2] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Crystal Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[3] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Monster Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[4] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Medal Bonus
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[5] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      DSA Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[8] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Troops Buff
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[7] * 100) | comma }}%
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 1220px;
                    height: 1px;
                    border: solid 0 #000;
                    background-color: #c5cbd7;
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sub_menu == 1">
          <div
            v-for="(continent, idx3) in [0, 1, 2]"
            :key="idx3"
            class="bg_card_staking_continent_2"
            style="position: absolute; top: 100px"
            v-bind:style="{ left: `${80 + 432 * idx3}px` }"
          >
            <div v-if="dashboard.individual.length > idx3">
              <div
                style="
                  width: 120px;
                  height: 120px;
                  border-radius: 40px;
                  border: solid 0 #000;
                  background-color: #e5eaf2;
                  position: absolute;
                  top: -20px;
                  left: 20px;
                  padding-left: 30px;
                  padding-top: 26px;
                "
              >
                <img src="/img/staking/icon-user.png" />
              </div>
              <img
                v-bind:src="`/img/staking/rank-${idx3 + 1}.png`"
                style="position: absolute; top: 0px; right: 20px"
              />
              <div
                v-if="
                  dashboard.individual[idx3].staking != null &&
                  dashboard.individual[idx3].staking.mainContinent != 0
                "
                style="
                  position: absolute;
                  left: 170px;
                  top: 24px;
                  font-family: Poppins;
                  font-size: 20px;
                  font-weight: 600;
                  letter-spacing: -0.2px;
                  text-align: left;
                  color: #202431;
                "
              >
                Continent {{ dashboard.individual[idx3].staking.mainContinent }}
              </div>
              <div
                style="position: absolute; left: 170px; top: 58px"
                class="bg_eth_address"
              >
                {{ showAddress(dashboard.individual[idx3].address) }}
              </div>
              <div
                style="
                  position: absolute;
                  left: 30px;
                  top: 129px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total Pledged
              </div>
              <div
                style="
                  position: absolute;
                  left: 32px;
                  top: 156px;
                  font-family: Poppins;
                  font-size: 40px;
                  font-weight: bold;
                  letter-spacing: -0.4px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ dashboard.individual[idx3].value.toFixed(2) | comma }}
              </div>
              <div
                style="
                  position: absolute;
                  right: 31px;
                  top: 165px;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
              <div
                style="
                  position: absolute;
                  left: calc(50% - 178px);
                  top: 227px;
                  width: 356px;
                  height: 1px;
                  opacity: 0.7;
                  border: solid 0 #000;
                  background-color: #c1c4d3;
                "
              ></div>
              <div
                v-if="dashboard.individual[idx3].staking != null"
                style="
                  width: 356px;
                  height: 160px;
                  position: absolute;
                  left: 30px;
                  top: 248px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 1.81;
                  letter-spacing: -0.16px;
                  color: #202431;
                "
              >
                {{ dashboard.individual[idx3].staking.comment }}
              </div>
            </div>
          </div>
          <div
            class="bg_staking_continent_list"
            style="position: absolute; left: calc(50% - 640px); top: 540px"
            v-bind:style="{
              height: `${153 + 104 * dashboard.individuals.length}px`,
            }"
          >
            <div
              style="
                position: absolute;
                top: 0px;
                left: 30px;
                width: 1220px;
                height: 93px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                padding-top: 45px;
                color: #202431;
              "
            >
              <div style="width: 100px; float: left; height: 100%">Rank</div>
              <div style="width: 200px; float: left; height: 100%">Address</div>
              <div style="width: 200px; float: left; height: 100%">
                Continent
              </div>
              <div style="width: 300px; float: left; height: 100%">
                Total Pledged
              </div>
              <div style="width: 420px; float: left; height: 100%">Comment</div>
              <div
                style="
                  width: 1220px;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
            <div
              v-for="(individual, idx4) in dashboard.individuals"
              :key="idx4"
              style="position: absolute; top: 93px; left: 30px; width: 1220px"
              v-bind:style="{ top: `${93 + 104 * idx4}px` }"
            >
              <div
                style="
                  width: 100%;
                  height: 104px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: center;
                  color: #202431;
                "
              >
                <div
                  style="
                    width: 100px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                >
                  Rank {{ idx4 + 4 }}
                </div>
                <div
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                    padding-left: 40px;
                  "
                >
                  <div class="bg_eth_address">
                    {{ showAddress(individual.address) }}
                  </div>
                </div>
                <div
                  v-if="
                    individual.staking != null &&
                    individual.staking.mainContinent != 0
                  "
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                >
                  Continent {{ individual.staking.mainContinent }}
                </div>
                <div
                  v-else
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                ></div>
                <div
                  style="
                    padding-right: 60px;
                    width: 300px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    text-align: right;
                  "
                >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 24px;
                      font-weight: bold;
                      letter-spacing: -0.24px;
                      text-align: right;
                      color: #202431;
                    "
                    >{{ individual.value.toFixed(2) | comma }}</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 20px;
                      margin-left: 5px;
                      font-weight: 500;
                      letter-spacing: -0.2px;
                      text-align: right;
                      color: #a5aaba;
                    "
                    >LOKA</span
                  >
                </div>
                <div
                  v-if="individual.staking != null"
                  style="
                    width: 420px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    padding-left: 50px;
                    padding-right: 50px;
                    font-family: Poppins;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.54;
                    letter-spacing: -0.13px;
                  "
                >
                  {{ individual.staking.comment }}
                </div>
                <div
                  style="
                    width: 1220px;
                    height: 1px;
                    border: solid 0 #000;
                    background-color: #c5cbd7;
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="menu == 1"
        class="bg_staking_stake"
        style="position: absolute; top: 720px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${283 + 104 * stake.continent.length}px`,
        }"
      >
        <div
          style="
            position: absolute;
            top: -60px;
            font-family: Poppins;
            width: 100%;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #f3741f;
          "
        >
          * The pledged amount and the ranking per continent will be updated on
          UTC 00:00 everyday
        </div>
        <div
          class="bg_staking_continent_list_2"
          style="position: absolute; left: calc(50% - 640px); top: 80px"
          v-bind:style="{
            height: `${153 + 104 * stake.continent.length}px`,
          }"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 30px;
              width: 1220px;
              height: 93px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              padding-top: 45px;
              color: #202431;
            "
          >
            <div style="width: 100px; float: left; height: 100%">Tier</div>
            <div style="width: 200px; float: left; height: 100%">Continent</div>
            <div style="width: 200px; float: left; height: 100%">
              Total Pledged
            </div>
            <div style="width: 460px; float: left; height: 100%">Effect</div>
            <div style="width: 260px; float: left; height: 100%">Pledge</div>
            <div
              style="
                width: 100%;
                height: 1px;
                border: solid 0 #000;
                background-color: #c5cbd7;
                position: absolute;
                bottom: 0px;
                left: 0px;
              "
            ></div>
          </div>
          <div
            v-for="(continent, idx6) in stake.continent"
            :key="idx6"
            style="position: absolute; top: 93px; left: 30px; width: 1220px"
            v-bind:style="{ top: `${93 + 104 * idx6}px` }"
          >
            <div
              style="
                width: 100%;
                height: 104px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                color: #202431;
              "
            >
              <div
                style="
                  width: 100px;
                  float: left;
                  height: 100%;
                  padding-top: 16px;
                "
              >
                <img
                  v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                />
              </div>
              <div style="width: 200px; float: left; height: 100%">
                <div
                  style="
                    margin-top: 16px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: -0.2px;
                    color: #202431;
                  "
                >
                  Continent {{ continent.continent }}
                </div>
                <div
                  style="
                    margin-left: calc(50% - 50px);
                    margin-top: 6px;
                    width: 100px;
                    height: 32px;
                    border-radius: 6px;
                    border: solid 0 #000;
                    background-color: #0060ff;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: left;
                    color: #fff;
                    padding-top: 4px;
                    cursor: pointer;
                  "
                  @click="popContinentRank(continent.continent)"
                >
                  <img
                    src="/img/staking/icon-rank.png"
                    style="margin-left: 10px"
                  />
                  <span style="vertical-align: middle; margin-left: 10px"
                    >Rank</span
                  >
                </div>
              </div>
              <div
                style="
                  padding-right: 20px;
                  width: 200px;
                  float: left;
                  height: 100%;
                  padding-top: 30px;
                  text-align: right;
                "
              >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 24px;
                    font-weight: bold;
                    letter-spacing: -0.24px;
                    text-align: right;
                    color: #202431;
                  "
                  >{{ continent.value.toFixed(2) | comma }}</span
                >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 20px;
                    margin-left: 5px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    text-align: right;
                    color: #a5aaba;
                  "
                  >LOKA</span
                >
              </div>
              <div
                style="
                  width: 460px;
                  float: left;
                  height: 100%;
                  padding-top: 10px;
                  padding-left: 50px;
                  padding-right: 50px;
                  font-family: Poppins;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 1.54;
                  letter-spacing: -0.13px;
                "
              >
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Resource Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[2] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Crystal Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[3] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Monster Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[4] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Medal Bonus
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[5] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    DSA Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[8] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Troops Buff
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[7] * 100) | comma }}%
                  </div>
                </div>
              </div>
              <div style="width: 260px; float: left; height: 100%">
                <div
                  style="
                    margin-left: calc(50% - 90px);
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #031243;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                  "
                  @click="popStake(continent.continent)"
                >
                  PLEDGE
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="menu == 2"
        class="bg_staking_main ddd"
        style="position: absolute; top: 720px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${670 + 104 * my_continents.length}px`,
        }"
      >
        <div
          style="
            width: 1280px;
            height: 320px;
            border-radius: 16px;
            border: solid 0 #000;
            background-color: #fff;
            position: absolute;
            left: calc(50% - 640px);
            top: 80px;
          "
        >
          <div
            style="
              width: 120px;
              height: 120px;
              border-radius: 40px;
              border: solid 0 #000;
              background-color: #e5eaf2;
              position: absolute;
              top: 40px;
              left: 40px;
              padding-left: 30px;
              padding-top: 26px;
            "
          >
            <img src="/img/staking/icon-user.png" />
          </div>
          <img
            src="/img/staking/icon-rank.png"
            style="position: absolute; left: 184px; top: 67px"
          />
          <div
            v-if="my.ranking == null || my.ranking == 0"
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #202431;
              position: absolute;
              left: 216px;
              top: 60px;
            "
          >
            Rank --
          </div>
          <div
            v-else
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #202431;
              position: absolute;
              left: 216px;
              top: 60px;
            "
          >
            Rank {{ my.ranking }}
          </div>
          <div
            style="position: absolute; left: 184px; top: 102px"
            class="bg_eth_address"
          >
            {{ showAddress(my.address) }}
          </div>
          <div
            style="
              position: absolute;
              left: 374px;
              top: 70px;
              width: 1px;
              height: 60px;
              border: solid 0 #000;
              background-color: #d9ddef;
            "
          ></div>
          <div
            style="
              position: absolute;
              left: 424px;
              top: 60px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: -0.16px;
              text-align: left;
              color: #a5aaba;
            "
          >
            Total Pledged
          </div>
          <div
            style="
              position: absolute;
              right: 690px;
              top: 90px;
              width: 200px;
              font-family: Poppins;
              font-size: 40px;
              font-weight: bold;
              letter-spacing: -0.4px;
              text-align: right;
              color: #202431;
            "
          >
            {{ my.staking.total.toFixed(2) | comma }}
          </div>
          <div
            style="
              position: absolute;
              right: 622px;
              top: 100px;
              font-family: Poppins;
              font-size: 24px;
              font-weight: 500;
              letter-spacing: -0.24px;
              text-align: right;
              color: #a5aaba;
            "
          >
            LOKA
          </div>
          <textarea
            placeholder="Please enter your self-introduction."
            v-model="input_comment"
            style="
              width: 400px;
              height: 72px;
              border-radius: 4px;
              border: solid 1px #dfe5ef;
              background-color: #fff;
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 20px;
              position: absolute;
              right: 40px;
              top: 40px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 500;
              line-height: 1.75;
              letter-spacing: -0.4px;
              text-align: left;
              color: #202431;
            "
          />
          <!-- <div
            style="
              position: absolute;
              right: 53px;
              bottom: 172px;
              font-family: Poppins;
              font-size: 13px;
              font-weight: 500;
              letter-spacing: -0.13px;
              text-align: right;
              color: #a5aaba;
            "
          >
            0 byte
          </div> -->
          <div
            style="
              position: absolute; right: 40px; bottom: 160px;
              width: 134px; height: 40px;
            "
          >
            <button
              style="
              display:block;
              width: 100%; height: 100%;
              border: 0; border-radius: 4px;
              background-color: #031243;
              color: #fff; font-size: 14px; font-weight:500;
              "
              @click="submitComment($event)"
            >Registration</button>
          </div>
          <div
            style="
              position: absolute;
              left: 40px;
              bottom: 140px;
              width: 1200px;
              height: 2px;
              border: solid 0 #000;
              background-color: #e5eaf2;
            "
          ></div>
          <div
            style="
              width: 400px;
              height: 80px;
              border-radius: 4px;
              border: solid 0 #000;
              background-color: #f2f4f8;
              position: absolute;
              bottom: 30px;
              right: 40px;
            "
          >
            <div v-if="my.reward == null">
              <div
                style="
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: left;
                  color: #202431;
                  position: absolute;
                  left: 30px;
                  top: 26px;
                "
              >
                No reward
              </div>
              <div
                style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  width: 180px;
                  height: 60px;
                  border-radius: 4px;
                  border: solid 0 #000;
                  background-color: #cad0da;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  text-align: center;
                  color: #fff;
                  padding-top: 18px;
                "
              >
                CLAIM
              </div>
            </div>
            <div v-else>
              <img
                v-if="my.reward.code == 81000101"
                src="/img/staking/tier1_2.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000102"
                src="/img/staking/tier1_2.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000103"
                src="/img/staking/tier3_4.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000104"
                src="/img/staking/tier3_4.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000105"
                src="/img/staking/tier5_6.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000106"
                src="/img/staking/tier5_6.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000107"
                src="/img/staking/tier7_8.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000108"
                src="/img/staking/tier7_8.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <img
                v-if="my.reward.code == 81000109"
                src="/img/staking/tier9.png"
                style="position: absolute; left: 30px; top: 24px"
              />
              <div
                style="
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  text-align: left;
                  color: #202431;
                  position: absolute;
                  left: 94px;
                  top: 26px;
                "
              >
                Tier {{ my.reward.code % 10 }}
              </div>
              <div
                style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  width: 180px;
                  height: 60px;
                  border-radius: 4px;
                  border: solid 0 #000;
                  background-color: #0060ff;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  text-align: center;
                  color: #fff;
                  padding-top: 18px;
                  cursor: pointer;
                "
                @click="clickClaimMyReward()"
              >
                CLAIM
              </div>
            </div>
          </div>
        </div>
        <div
          class="bg_staking_continent_list_2"
          style="position: absolute; left: calc(50% - 640px); top: 430px"
          v-bind:style="{
            height: `${153 + 104 * my_continents.length}px`,
          }"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 30px;
              width: 1220px;
              height: 93px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              padding-top: 45px;
              color: #202431;
            "
          >
            <div style="width: 100px; float: left; height: 100%">Tier</div>
            <div style="width: 300px; float: left; height: 100%">Continent</div>
            <div style="width: 400px; float: left; height: 100%">Pledged</div>
            <div style="width: 420px; float: left; height: 100%">
              Management
            </div>
            <div
              style="
                width: 100%;
                height: 1px;
                border: solid 0 #000;
                background-color: #c5cbd7;
                position: absolute;
                bottom: 0px;
                left: 0px;
              "
            ></div>
          </div>
          <div
            v-for="(continent, idx7) in my_continents"
            :key="idx7"
            style="position: absolute; top: 93px; left: 30px; width: 1220px"
            v-bind:style="{ top: `${93 + 104 * idx7}px` }"
          >
            <div
              style="
                width: 100%;
                height: 104px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                color: #202431;
              "
            >
              <div
                style="
                  width: 100px;
                  float: left;
                  height: 100%;
                  padding-top: 16px;
                "
              >
                <img
                  v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                />
              </div>
              <div style="width: 300px; float: left; height: 100%">
                <div
                  style="
                    margin-top: 16px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: -0.2px;
                    color: #202431;
                  "
                >
                  Continent {{ continent.continent }}
                </div>
                <div
                  style="
                    margin-left: calc(50% - 50px);
                    margin-top: 6px;
                    width: 100px;
                    height: 32px;
                    border-radius: 6px;
                    border: solid 0 #000;
                    background-color: #0060ff;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: left;
                    color: #fff;
                    padding-top: 4px;
                    cursor: pointer;
                  "
                  @click="popContinentRank(continent.continent)"
                >
                  <img
                    src="/img/staking/icon-rank.png"
                    style="margin-left: 10px"
                  />
                  <span style="vertical-align: middle; margin-left: 10px"
                    >Rank</span
                  >
                </div>
              </div>
              <div
                style="
                  padding-right: 100px;
                  width: 400px;
                  float: left;
                  height: 100%;
                  padding-top: 30px;
                  text-align: right;
                "
              >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 24px;
                    font-weight: bold;
                    letter-spacing: -0.24px;
                    text-align: right;
                    color: #202431;
                  "
                  >{{ continent.value.toFixed(2) | comma }}</span
                >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 20px;
                    margin-left: 5px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    text-align: right;
                    color: #a5aaba;
                  "
                  >LOKA</span
                >
              </div>
              <div style="width: 420px; float: left; height: 100%">
                <div
                  style="
                    margin-left: 20px;
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #031243;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                    float: left;
                  "
                  @click="popStake(continent.continent)"
                >
                  ADD
                </div>
                <div
                  style="
                    margin-right: 20px;
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #fc6a5b;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                    float: right;
                  "
                  @click="popUnStake(continent.continent)"
                >
                  UNPLEDGE
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.popup_stake == true ||
        modals.popup_unstake == true ||
        modals.continent_rank == true ||
        modals.table == true ||
        modals.process_stake == true ||
        modals.process_unstake == true ||
        $store.state.account.modals.approval == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.popup_stake"
      style="
        position: fixed;
        top: calc((100% - 580px) / 2);
        left: calc((100% - 600px) / 2);
        text-align: center;
        width: 600px;
        height: 580px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        PLEDGE
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        style="
          position: absolute;
          top: 130px;
          left: 40px;
          width: 520px;
          height: 80px;
          border-radius: 4px;
          border: solid 1px #c6dcff;
          background-color: #edf4ff;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 20px;
        "
      >
        <span
          style="
            font-family: Poppins;
            font-size: 20px;
            font-weight: 500;
            text-align: left;
            color: #202431;
            float: left;
            margin-top: 2px;
          "
        >
          Balance
        </span>
        <span
          style="
            width: 320px;
            float: left;
            font-family: Poppins;
            font-size: 28px;
            font-weight: bold;
            letter-spacing: -0.28px;
            text-align: right;
            color: #202431;
          "
        >
          {{ balance }}
        </span>
        <span
          style="
            font-family: Poppins;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: -0.24px;
            text-align: right;
            color: #a5aaba;
            float: right;
          "
        >
          LOKA
        </span>
      </div>
      <div
        style="
          position: absolute;
          left: 40px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          text-align: left;
          color: #202431;
        "
      >
        Amount
      </div>
      <input
        type="text"
        v-model="input_price"
        style="
          width: 389px;
          height: 70px;
          border-radius: 4px;
          border: solid 1px #dfe5ef;
          background-color: #fff;
          padding-left: 20px;
          padding-right: 100px;
          text-align: right;
          position: absolute;
          right: 40px;
          top: 260px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: -0.5px;
          color: #202431;
        "
      />
      <div
        style="
          position: absolute;
          right: 68px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          letter-spacing: -0.2px;
          text-align: right;
          color: #a5aaba;
        "
      >
        LOKA
      </div>
      <div
        style="
          position: absolute;
          top: 370px;
          left: calc(50% - 260px);
          width: 520px;
          height: 70px;
          border-radius: 10px;
          border: solid 0 #000;
          background-color: #edf0f6;
          font-family: Poppins;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          color: #969caf;
          padding-top: 12px;
        "
      >
        Please ensure that you typed the desired amount of LOKA correctly,<br />
        before pressing the PLEDGE button.
      </div>
      <div
        style="
          position: absolute;
          bottom: 40px;
          left: calc(50% - 140px);
          width: 280px;
          height: 70px;
          border-radius: 8px;
          border: solid 0 #000;
          background-color: #0a1844;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #fff;
          padding-top: 22px;
          cursor: pointer;
        "
        @click="clickStake()"
      >
        PLEDGE
      </div>
    </div>
    <div
      v-if="modals.popup_unstake"
      style="
        position: fixed;
        top: calc((100% - 580px) / 2);
        left: calc((100% - 600px) / 2);
        text-align: center;
        width: 600px;
        height: 580px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        UNPLEDGE
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        style="
          position: absolute;
          top: 130px;
          left: 40px;
          width: 520px;
          height: 80px;
          border-radius: 4px;
          border: solid 1px #c6dcff;
          background-color: #edf4ff;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 20px;
        "
      >
        <span
          style="
            font-family: Poppins;
            font-size: 20px;
            font-weight: 500;
            text-align: left;
            color: #202431;
            float: left;
            margin-top: 2px;
          "
        >
          Pledged
        </span>
        <span
          style="
            width: 320px;
            float: left;
            font-family: Poppins;
            font-size: 28px;
            font-weight: bold;
            letter-spacing: -0.28px;
            text-align: right;
            color: #202431;
          "
        >
          {{ staked }}
        </span>
        <span
          style="
            font-family: Poppins;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: -0.24px;
            text-align: right;
            color: #a5aaba;
            float: right;
          "
        >
          LOKA
        </span>
      </div>
      <div
        style="
          position: absolute;
          left: 40px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          text-align: left;
          color: #202431;
        "
      >
        Amount
      </div>
      <input
        type="text"
        v-model="input_price"
        style="
          width: 389px;
          height: 70px;
          border-radius: 4px;
          border: solid 1px #dfe5ef;
          background-color: #fff;
          padding-left: 20px;
          padding-right: 100px;
          text-align: right;
          position: absolute;
          right: 40px;
          top: 260px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: -0.5px;
          color: #202431;
        "
      />
      <div
        style="
          position: absolute;
          right: 68px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          letter-spacing: -0.2px;
          text-align: right;
          color: #a5aaba;
        "
      >
        LOKA
      </div>
      <div
        style="
          position: absolute;
          top: 370px;
          left: calc(50% - 260px);
          width: 520px;
          height: 70px;
          border-radius: 10px;
          border: solid 0 #000;
          background-color: #fcd1cd;
          font-family: Poppins;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          color: #f69990;
          padding-top: 12px;
        "
      >
        Please ensure that you typed the desired amount of LOKA correctly,
        <br />
        before pressing the UNPLEDGE button.
      </div>
      <div
        style="
          position: absolute;
          bottom: 40px;
          left: calc(50% - 140px);
          width: 280px;
          height: 70px;
          border-radius: 8px;
          border: solid 0 #000;
          background-color: #fc6a5b;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #fff;
          padding-top: 22px;
          cursor: pointer;
        "
        @click="clickUnstake()"
      >
        UNPLEDGE
      </div>
    </div>
    <div
      v-if="modals.continent_rank"
      style="
        position: fixed;
        top: calc((100% - 1140px) / 2);
        left: calc((100% - 1140px) / 2);
        text-align: center;
        width: 1140px;
        height: 1140px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        CONTINENT {{ ranking.continent }} > INDIVIDUAL RANK
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        class="bg_staking_continent_list_popup"
        style="position: absolute; left: calc(50% - 570px); top: 80px"
      >
        <div
          style="
            position: absolute;
            top: 40px;
            left: 40px;
            width: 1060px;
            height: 70px;
            border-radius: 4px;
            border: solid 0 #000;
            background-color: #edf0f6;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: -0.16px;
            text-align: center;
            padding-top: 25px;
            color: #202431;
          "
        >
          <div style="width: 100px; float: left; height: 100%">Rank</div>
          <div style="width: 200px; float: left; height: 100%">Address</div>
          <div style="width: 300px; float: left; height: 100%">
            Total Pledged
          </div>
          <div style="width: 460px; float: left; height: 100%">Comment</div>
        </div>
        <div style="position: absolute; top: 110px; left: 40px; width: 1220px">
          <div
            v-for="(individual, idx5) in ranking.individual"
            :key="idx5"
            style="
              width: 100%;
              height: 84px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              color: #202431;
            "
          >
            <div
              style="width: 100px; float: left; height: 100%; padding-top: 26px"
            >
              Rank {{ idx5 + 1 }}
            </div>
            <div
              style="
                width: 200px;
                float: left;
                height: 100%;
                padding-top: 26px;
                padding-left: 40px;
              "
            >
              <div class="bg_eth_address">
                {{ showAddress(individual.address) }}
              </div>
            </div>
            <div
              style="
                padding-right: 60px;
                width: 300px;
                float: left;
                height: 100%;
                padding-top: 20px;
                text-align: right;
              "
            >
              <span
                style="
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #202431;
                "
                >{{ individual.value.toFixed(2) | comma }}</span
              >
              <span
                style="
                  font-family: Poppins;
                  font-size: 20px;
                  margin-left: 5px;
                  font-weight: 500;
                  letter-spacing: -0.2px;
                  text-align: right;
                  color: #a5aaba;
                "
                >LOKA</span
              >
            </div>
            <div
              v-if="individual.staking != null"
              style="
                width: 460px;
                float: left;
                height: 100%;
                padding-top: 20px;
                padding-left: 50px;
                padding-right: 50px;
                font-family: Poppins;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.54;
                letter-spacing: -0.13px;
              "
            >
              {{ individual.staking.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modals.table"
      style="
        position: fixed;
        top: calc((100% - 940px) / 2);
        left: calc((100% - 1140px) / 2);
        text-align: center;
        width: 1140px;
        height: 940px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        PLEDGING BONUS
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        class="bg_staking_continent_list_popup"
        style="
          position: absolute;
          left: calc(50% - 570px);
          top: 80px;
          padding-top: 50px;
        "
      >
        <img src="/img/table-02.png" />
      </div>
    </div>
    <div
      v-if="modals.process_stake"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Pledging processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for pledging...<br /><br />
        It may take up to 1-5 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://etherscan.io/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.process_unstake"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Unstaking processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for unstaking...<br /><br />
        It may take up to 1-5 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://etherscan.io/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <!-- <div class="page-header clear-filter" filter-color="black2">
      <img
        src="/img/staking/main-img.png"
        width="1360px"
        height="556px"
        style="position: absolute; left: calc(50% - 680px)"
      />
      <div
        class="bg_bonus-area"
        v-bind:style="{ height: getTotalHeight() }"
      ></div>
      <div
        style="
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0px;
          left: 0px;
        "
      >
        <div class="LOKA-STAKING-POOLS">LOKA Pledging Pools</div>
        <div class="LOKA-STAKING-POOLS-DESC">
          Empower the continent by staking LOKA!<br />
          Gather the strength together to boost your continent!
        </div>
      </div>
      <div
        style="
          position: absolute;
          top: 540px;
          height: 90px;
          width: 100%;
          border: solid 0 #000;
          background-color: #1b0c5b;
          text-align: center;
        "
      >
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 0 }"
          @click="clickMenu(0)"
        >
          Dashboard
          <div class="staking_tab_bar" v-if="menu == 0"></div>
        </div>
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 1 }"
          @click="clickMenu(1)"
        >
          Stake
          <div class="staking_tab_bar" v-if="menu == 1"></div>
        </div>
        <div
          class="staking_tab"
          v-bind:class="{ on: menu == 2 }"
          @click="clickMenu(2)"
        >
          My Pledging
          <div class="staking_tab_bar" v-if="menu == 2"></div>
        </div>
      </div>
      <div
        v-if="menu == 0"
        class="bg_staking_main"
        style="position: absolute; top: 1066px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${
            800 +
            104 * dashboard.continents.length * (1 - sub_menu) +
            104 * dashboard.individuals.length * sub_menu
          }px`,
        }"
      >
        <div
          style="
            position: absolute;
            top: -406px;
            font-family: Poppins;
            width: 100%;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #f3741f;
          "
        >
          * The staked amount and the ranking per continent will be updated on
          UTC 00:00 everyday
        </div>
        <div
          style="
            width: 1440px;
            height: 370px;
            border: solid 0 #000;
            background-color: #2e334d;
            position: absolute;
            top: -370px;
            left: 0px;
          "
        >
          <div
            style="
              width: 1280px;
              height: 200px;
              border-radius: 16px;
              border: solid 0 #000;
              background-color: #fff;
              position: absolute;
              left: 80px;
              top: 70px;
            "
          >
            <div
              style="
                width: 120px;
                height: 120px;
                margin: 0 23px 0 0;
                padding-top: 26px;
                padding-left: 23px;
                border-radius: 40px;
                border: solid 0 #000;
                background-color: #e5eaf2;
                position: absolute;
                left: 40px;
                top: 40px;
              "
            >
              <img src="/img/icon-loka-copy-2.png" />
            </div>
            <div
              style="
                position: absolute;
                left: 185px;
                top: 60px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: -0.16px;
                text-align: left;
                color: #a5aaba;
              "
            >
              Total Pledged
            </div>
            <div
              style="
                position: absolute;
                left: 185px;
                top: 90px;
                font-family: Poppins;
                font-size: 40px;
                font-weight: bold;
                letter-spacing: -0.4px;
                text-align: left;
                color: #202431;
              "
            >
              {{ dashboard.totalValue.toFixed(2) | comma }}
              <span
                style="
                  font-family: Poppins;
                  margin-left: 10px;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                LOKA
              </span>
            </div>
            <div
              style="
                width: 120px;
                height: 120px;
                margin: 0 23px 0 0;
                padding-top: 26px;
                padding-left: 23px;
                border-radius: 40px;
                border: solid 0 #000;
                background-color: #e5eaf2;
                position: absolute;
                left: 680px;
                top: 40px;
              "
            >
              <img src="/img/icon-user.png" />
            </div>
            <div
              style="
                position: absolute;
                left: 825px;
                top: 60px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 500;
                letter-spacing: -0.16px;
                text-align: left;
                color: #a5aaba;
              "
            >
              Total Holder
            </div>
            <div
              style="
                position: absolute;
                left: 825px;
                top: 90px;
                font-family: Poppins;
                font-size: 40px;
                font-weight: bold;
                letter-spacing: -0.4px;
                text-align: left;
                color: #202431;
              "
            >
              {{ dashboard.totalHolder | comma }}
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: -24px;
            left: calc(50% - 292px);
            height: 48px;
            width: 584px;
            border-radius: 30px;
            border: solid 0 #000;
            background-color: #091033;
          "
        >
          <div
            class="staking_main_tab"
            v-bind:class="{ on: sub_menu == 0 }"
            @click="clickSubMenu(0)"
          >
            Continent
          </div>
          <div
            class="staking_main_tab"
            v-bind:class="{ on: sub_menu == 1 }"
            @click="clickSubMenu(1)"
          >
            Individual
          </div>
        </div>
        <div v-if="sub_menu == 0">
          <div
            v-for="(continent, idx1) in [0, 1, 2]"
            :key="idx1"
            class="bg_card_staking_continent"
            style="position: absolute; top: 100px"
            v-bind:style="{ left: `${80 + 432 * idx1}px` }"
          >
            <div v-if="dashboard.continent.length > idx1">
              <div
                style="
                  width: 120px;
                  height: 120px;
                  border-radius: 40px;
                  border: solid 0 #000;
                  background-color: #e5eaf2;
                  position: absolute;
                  top: -20px;
                  left: 20px;
                  padding-left: 20px;
                  padding-top: 26px;
                "
              >
                <img src="/img/staking/icon-continent.png" />
              </div>
              <img
                v-bind:src="`/img/staking/label-tier-${dashboard.continent[idx1].tier}.png`"
                style="position: absolute; top: 0px; right: 20px"
              />
              <div
                style="
                  position: absolute;
                  left: 170px;
                  top: 24px;
                  font-family: Poppins;
                  font-size: 20px;
                  font-weight: 600;
                  letter-spacing: -0.2px;
                  text-align: left;
                  color: #202431;
                "
              >
                Continent {{ dashboard.continent[idx1].continent }}
              </div>
              <div
                style="
                  position: absolute;
                  left: 170px;
                  top: 58px;
                  width: 100px;
                  height: 32px;
                  border-radius: 6px;
                  border: solid 0 #000;
                  background-color: #0060ff;
                  text-align: left;
                  font-family: Poppins;
                  font-size: 14px;
                  font-weight: 500;
                  text-align: left;
                  color: #fff;
                  padding-top: 4px;
                  cursor: pointer;
                "
                @click="popContinentRank(dashboard.continent[idx1].continent)"
              >
                <img
                  src="/img/staking/icon-rank.png"
                  style="margin-left: 10px"
                />
                <span style="vertical-align: middle; margin-left: 10px"
                  >Rank</span
                >
              </div>
              <div
                style="
                  position: absolute;
                  left: 30px;
                  top: 129px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total Pledged
              </div>
              <div
                style="
                  position: absolute;
                  left: 32px;
                  top: 156px;
                  font-family: Poppins;
                  font-size: 40px;
                  font-weight: bold;
                  letter-spacing: -0.4px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ dashboard.continent[idx1].value.toFixed(2) | comma }}
              </div>
              <div
                style="
                  position: absolute;
                  right: 31px;
                  top: 165px;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
              <div
                style="
                  position: absolute;
                  left: calc(50% - 178px);
                  top: 227px;
                  width: 356px;
                  height: 1px;
                  opacity: 0.7;
                  border: solid 0 #000;
                  background-color: #c1c4d3;
                "
              ></div>
              <div
                style="
                  width: 356px;
                  height: 160px;
                  position: absolute;
                  left: 30px;
                  top: 248px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 1.81;
                  letter-spacing: -0.16px;
                  color: #202431;
                "
              >
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Resource Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[2] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Crystal Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[3] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Monster Regen
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[4] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Medal Bonus
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[5] * 100) | comma }}%
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    CvC Reward
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    -
                  </div>
                </div>
                <div style="margin-bottom: 6px; width: 356px; height: 20px">
                  <div
                    style="
                      text-align: left;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    Troops Buff
                  </div>
                  <div
                    style="
                      text-align: right;
                      width: 178px;
                      height: 100%;
                      float: left;
                    "
                  >
                    {{ (dashboard.continent[idx1].rewards[7] * 100) | comma }}%
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="bg_staking_continent_list"
            style="position: absolute; left: calc(50% - 640px); top: 570px"
            v-bind:style="{
              height: `${153 + 104 * dashboard.continents.length}px`,
            }"
          >
            <div
              style="
                position: absolute;
                top: 0px;
                left: 30px;
                width: 1220px;
                height: 93px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                padding-top: 45px;
                color: #202431;
              "
            >
              <div style="width: 100px; float: left; height: 100%">Tier</div>
              <div style="width: 216px; float: left; height: 100%">
                Continent
              </div>
              <div style="width: 400px; float: left; height: 100%">
                Total Pledged
              </div>
              <div style="width: 504px; float: left; height: 100%">Effect</div>
              <div
                style="
                  width: 1220px;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
            <div
              v-for="(continent, idx2) in dashboard.continents"
              :key="idx2"
              style="position: absolute; left: 30px; width: 1220px"
              v-bind:style="{ top: `${93 + 104 * idx2}px` }"
            >
              <div
                style="
                  width: 100%;
                  height: 104px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: center;
                  color: #202431;
                "
              >
                <div
                  style="
                    width: 100px;
                    float: left;
                    height: 100%;
                    padding-top: 16px;
                  "
                >
                  <img
                    v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                  />
                </div>
                <div style="width: 216px; float: left; height: 100%">
                  <div
                    style="
                      margin-top: 16px;
                      font-family: Poppins;
                      font-size: 16px;
                      font-weight: 600;
                      letter-spacing: -0.2px;
                      color: #202431;
                    "
                  >
                    Continent {{ continent.continent }}
                  </div>
                  <div
                    style="
                      margin-left: calc(50% - 50px);
                      margin-top: 6px;
                      width: 100px;
                      height: 32px;
                      border-radius: 6px;
                      border: solid 0 #000;
                      background-color: #0060ff;
                      font-family: Poppins;
                      font-size: 14px;
                      font-weight: 500;
                      text-align: left;
                      color: #fff;
                      padding-top: 4px;
                      cursor: pointer;
                    "
                    @click="popContinentRank(continent.continent)"
                  >
                    <img
                      src="/img/staking/icon-rank.png"
                      style="margin-left: 10px"
                    />
                    <span style="vertical-align: middle; margin-left: 10px"
                      >Rank</span
                    >
                  </div>
                </div>
                <div
                  style="
                    padding-right: 100px;
                    width: 400px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    text-align: right;
                  "
                >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 24px;
                      font-weight: bold;
                      letter-spacing: -0.24px;
                      text-align: right;
                      color: #202431;
                    "
                    >{{ continent.value.toFixed(2) | comma }}</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 20px;
                      margin-left: 5px;
                      font-weight: 500;
                      letter-spacing: -0.2px;
                      text-align: right;
                      color: #a5aaba;
                    "
                    >LOKA</span
                  >
                </div>
                <div
                  style="
                    width: 504px;
                    float: left;
                    height: 100%;
                    padding-top: 10px;
                    padding-left: 50px;
                    padding-right: 50px;
                    font-family: Poppins;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.54;
                    letter-spacing: -0.13px;
                  "
                >
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Resource Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[2] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Crystal Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[3] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Monster Regen
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[4] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Medal Bonus
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[5] * 100) | comma }}%
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-right: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      CvC Reward
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      -
                    </div>
                  </div>
                  <div
                    style="
                      width: 50%;
                      float: left;
                      height: 20px;
                      margin-bottom: 5px;
                      padding-left: 20px;
                    "
                  >
                    <div
                      style="
                        width: 70%;
                        float: left;
                        height: 20px;
                        text-align: left;
                      "
                    >
                      Troops Buff
                    </div>
                    <div
                      style="
                        width: 30%;
                        float: left;
                        height: 20px;
                        text-align: right;
                      "
                    >
                      {{ (continent.rewards[7] * 100) | comma }}%
                    </div>
                  </div>
                </div>
                <div
                  style="
                    width: 1220px;
                    height: 1px;
                    border: solid 0 #000;
                    background-color: #c5cbd7;
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sub_menu == 1">
          <div
            v-for="(continent, idx3) in [0, 1, 2]"
            :key="idx3"
            class="bg_card_staking_continent_2"
            style="position: absolute; top: 100px"
            v-bind:style="{ left: `${80 + 432 * idx3}px` }"
          >
            <div v-if="dashboard.individual.length > idx3">
              <div
                style="
                  width: 120px;
                  height: 120px;
                  border-radius: 40px;
                  border: solid 0 #000;
                  background-color: #e5eaf2;
                  position: absolute;
                  top: -20px;
                  left: 20px;
                  padding-left: 30px;
                  padding-top: 26px;
                "
              >
                <img src="/img/staking/icon-user.png" />
              </div>
              <img
                v-bind:src="`/img/staking/rank-${idx3 + 1}.png`"
                style="position: absolute; top: 0px; right: 20px"
              />
              <div
                v-if="
                  dashboard.individual[idx3].staking != null &&
                  dashboard.individual[idx3].staking.mainContinent != 0
                "
                style="
                  position: absolute;
                  left: 170px;
                  top: 24px;
                  font-family: Poppins;
                  font-size: 20px;
                  font-weight: 600;
                  letter-spacing: -0.2px;
                  text-align: left;
                  color: #202431;
                "
              >
                Continent {{ dashboard.individual[idx3].staking.mainContinent }}
              </div>
              <div
                style="position: absolute; left: 170px; top: 58px"
                class="bg_eth_address"
              >
                {{ showAddress(dashboard.individual[idx3].address) }}
              </div>
              <div
                style="
                  position: absolute;
                  left: 30px;
                  top: 129px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  letter-spacing: -0.16px;
                  text-align: left;
                  color: #a5aaba;
                "
              >
                Total Pledged
              </div>
              <div
                style="
                  position: absolute;
                  left: 32px;
                  top: 156px;
                  font-family: Poppins;
                  font-size: 40px;
                  font-weight: bold;
                  letter-spacing: -0.4px;
                  text-align: left;
                  color: #202431;
                "
              >
                {{ dashboard.individual[idx3].value.toFixed(2) | comma }}
              </div>
              <div
                style="
                  position: absolute;
                  right: 31px;
                  top: 165px;
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: 500;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #a5aaba;
                "
              >
                LOKA
              </div>
              <div
                style="
                  position: absolute;
                  left: calc(50% - 178px);
                  top: 227px;
                  width: 356px;
                  height: 1px;
                  opacity: 0.7;
                  border: solid 0 #000;
                  background-color: #c1c4d3;
                "
              ></div>
              <div
                v-if="dashboard.individual[idx3].staking != null"
                style="
                  width: 356px;
                  height: 160px;
                  position: absolute;
                  left: 30px;
                  top: 248px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 500;
                  line-height: 1.81;
                  letter-spacing: -0.16px;
                  color: #202431;
                "
              >
                {{ dashboard.individual[idx3].staking.comment }}
              </div>
            </div>
          </div>
          <div
            class="bg_staking_continent_list"
            style="position: absolute; left: calc(50% - 640px); top: 540px"
            v-bind:style="{
              height: `${153 + 104 * dashboard.individuals.length}px`,
            }"
          >
            <div
              style="
                position: absolute;
                top: 0px;
                left: 30px;
                width: 1220px;
                height: 93px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                padding-top: 45px;
                color: #202431;
              "
            >
              <div style="width: 100px; float: left; height: 100%">Rank</div>
              <div style="width: 200px; float: left; height: 100%">Address</div>
              <div style="width: 200px; float: left; height: 100%">
                Continent
              </div>
              <div style="width: 300px; float: left; height: 100%">
                Total Pledged
              </div>
              <div style="width: 420px; float: left; height: 100%">Comment</div>
              <div
                style="
                  width: 1220px;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
            <div
              v-for="(individual, idx4) in dashboard.individuals"
              :key="idx4"
              style="position: absolute; top: 93px; left: 30px; width: 1220px"
              v-bind:style="{ top: `${93 + 104 * idx4}px` }"
            >
              <div
                style="
                  width: 100%;
                  height: 104px;
                  font-family: Poppins;
                  font-size: 16px;
                  font-weight: 600;
                  letter-spacing: -0.16px;
                  text-align: center;
                  color: #202431;
                "
              >
                <div
                  style="
                    width: 100px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                >
                  Rank {{ idx4 + 4 }}
                </div>
                <div
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                    padding-left: 40px;
                  "
                >
                  <div class="bg_eth_address">
                    {{ showAddress(individual.address) }}
                  </div>
                </div>
                <div
                  v-if="
                    individual.staking != null &&
                    individual.staking.mainContinent != 0
                  "
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                >
                  Continent {{ individual.staking.mainContinent }}
                </div>
                <div
                  v-else
                  style="
                    width: 200px;
                    float: left;
                    height: 100%;
                    padding-top: 36px;
                  "
                ></div>
                <div
                  style="
                    padding-right: 60px;
                    width: 300px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    text-align: right;
                  "
                >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 24px;
                      font-weight: bold;
                      letter-spacing: -0.24px;
                      text-align: right;
                      color: #202431;
                    "
                    >{{ individual.value.toFixed(2) | comma }}</span
                  >
                  <span
                    style="
                      font-family: Poppins;
                      font-size: 20px;
                      margin-left: 5px;
                      font-weight: 500;
                      letter-spacing: -0.2px;
                      text-align: right;
                      color: #a5aaba;
                    "
                    >LOKA</span
                  >
                </div>
                <div
                  v-if="individual.staking != null"
                  style="
                    width: 420px;
                    float: left;
                    height: 100%;
                    padding-top: 30px;
                    padding-left: 50px;
                    padding-right: 50px;
                    font-family: Poppins;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 1.54;
                    letter-spacing: -0.13px;
                  "
                >
                  {{ individual.staking.comment }}
                </div>
                <div
                  style="
                    width: 1220px;
                    height: 1px;
                    border: solid 0 #000;
                    background-color: #c5cbd7;
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="menu == 1"
        class="bg_staking_stake"
        style="position: absolute; top: 720px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${283 + 104 * stake.continent.length}px`,
        }"
      >
        <div
          style="
            position: absolute;
            top: -60px;
            font-family: Poppins;
            width: 100%;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 500;
            text-align: center;
            color: #f3741f;
          "
        >
          * The staked amount and the ranking per continent will be updated on
          UTC 00:00 everyday
        </div>
        <div
          class="bg_staking_continent_list_2"
          style="position: absolute; left: calc(50% - 640px); top: 80px"
          v-bind:style="{
            height: `${153 + 104 * stake.continent.length}px`,
          }"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 30px;
              width: 1220px;
              height: 93px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              padding-top: 45px;
              color: #202431;
            "
          >
            <div style="width: 100px; float: left; height: 100%">Tier</div>
            <div style="width: 200px; float: left; height: 100%">Continent</div>
            <div style="width: 200px; float: left; height: 100%">
              Total Pledged
            </div>
            <div style="width: 460px; float: left; height: 100%">Effect</div>
            <div style="width: 260px; float: left; height: 100%">Stake</div>
            <div
              style="
                width: 100%;
                height: 1px;
                border: solid 0 #000;
                background-color: #c5cbd7;
                position: absolute;
                bottom: 0px;
                left: 0px;
              "
            ></div>
          </div>
          <div
            v-for="(continent, idx6) in stake.continent"
            :key="idx6"
            style="position: absolute; top: 93px; left: 30px; width: 1220px"
            v-bind:style="{ top: `${93 + 104 * idx6}px` }"
          >
            <div
              style="
                width: 100%;
                height: 104px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                color: #202431;
              "
            >
              <div
                style="
                  width: 100px;
                  float: left;
                  height: 100%;
                  padding-top: 16px;
                "
              >
                <img
                  v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                />
              </div>
              <div style="width: 200px; float: left; height: 100%">
                <div
                  style="
                    margin-top: 16px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: -0.2px;
                    color: #202431;
                  "
                >
                  Continent {{ continent.continent }}
                </div>
                <div
                  style="
                    margin-left: calc(50% - 50px);
                    margin-top: 6px;
                    width: 100px;
                    height: 32px;
                    border-radius: 6px;
                    border: solid 0 #000;
                    background-color: #0060ff;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: left;
                    color: #fff;
                    padding-top: 4px;
                    cursor: pointer;
                  "
                  @click="popContinentRank(continent.continent)"
                >
                  <img
                    src="/img/staking/icon-rank.png"
                    style="margin-left: 10px"
                  />
                  <span style="vertical-align: middle; margin-left: 10px"
                    >Rank</span
                  >
                </div>
              </div>
              <div
                style="
                  padding-right: 20px;
                  width: 200px;
                  float: left;
                  height: 100%;
                  padding-top: 30px;
                  text-align: right;
                "
              >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 24px;
                    font-weight: bold;
                    letter-spacing: -0.24px;
                    text-align: right;
                    color: #202431;
                  "
                  >{{ continent.value.toFixed(2) | comma }}</span
                >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 20px;
                    margin-left: 5px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    text-align: right;
                    color: #a5aaba;
                  "
                  >LOKA</span
                >
              </div>
              <div
                style="
                  width: 460px;
                  float: left;
                  height: 100%;
                  padding-top: 10px;
                  padding-left: 50px;
                  padding-right: 50px;
                  font-family: Poppins;
                  font-size: 13px;
                  font-weight: 500;
                  line-height: 1.54;
                  letter-spacing: -0.13px;
                "
              >
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Resource Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[2] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Crystal Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[3] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Monster Regen
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[4] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Medal Bonus
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[5] * 100) | comma }}%
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-right: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    CvC Reward
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    -
                  </div>
                </div>
                <div
                  style="
                    width: 50%;
                    float: left;
                    height: 20px;
                    margin-bottom: 5px;
                    padding-left: 20px;
                  "
                >
                  <div
                    style="
                      width: 70%;
                      float: left;
                      height: 20px;
                      text-align: left;
                    "
                  >
                    Troops Buff
                  </div>
                  <div
                    style="
                      width: 30%;
                      float: left;
                      height: 20px;
                      text-align: right;
                    "
                  >
                    {{ (continent.rewards[7] * 100) | comma }}%
                  </div>
                </div>
              </div>
              <div style="width: 260px; float: left; height: 100%">
                <div
                  style="
                    margin-left: calc(50% - 90px);
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #031243;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                  "
                  @click="popStake(continent.continent)"
                >
                  PLEDGE
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="menu == 2"
        class="bg_staking_main"
        style="position: absolute; top: 720px; left: calc(50% - 720px)"
        v-bind:style="{
          height: `${550 + 104 * my_continents.length}px`,
        }"
      >
        <div
          style="
            width: 1280px;
            height: 200px;
            border-radius: 16px;
            border: solid 0 #000;
            background-color: #fff;
            position: absolute;
            left: calc(50% - 640px);
            top: 80px;
          "
        >
          <div
            style="
              width: 120px;
              height: 120px;
              border-radius: 40px;
              border: solid 0 #000;
              background-color: #e5eaf2;
              position: absolute;
              top: 40px;
              left: 40px;
              padding-left: 30px;
              padding-top: 26px;
            "
          >
            <img src="/img/staking/icon-user.png" />
          </div>
          <img
            src="/img/staking/icon-rank.png"
            style="position: absolute; left: 184px; top: 67px"
          />
          <div
            v-if="my.ranking == null || my.ranking == 0"
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #202431;
              position: absolute;
              left: 216px;
              top: 60px;
            "
          >
            Rank --
          </div>
          <div
            v-else
            style="
              font-family: Poppins;
              font-size: 20px;
              font-weight: 600;
              letter-spacing: -0.2px;
              text-align: left;
              color: #202431;
              position: absolute;
              left: 216px;
              top: 60px;
            "
          >
            Rank {{ my.ranking }}
          </div>
          <div
            style="position: absolute; left: 184px; top: 102px"
            class="bg_eth_address"
          >
            {{ showAddress(my.address) }}
          </div>
          <div
            style="
              position: absolute;
              left: 374px;
              top: 70px;
              width: 1px;
              height: 60px;
              border: solid 0 #000;
              background-color: #d9ddef;
            "
          ></div>
          <div
            style="
              position: absolute;
              left: 424px;
              top: 60px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 500;
              letter-spacing: -0.16px;
              text-align: left;
              color: #a5aaba;
            "
          >
            Total Pledged
          </div>
          <div
            style="
              position: absolute;
              right: 690px;
              top: 90px;
              width: 200px;
              font-family: Poppins;
              font-size: 40px;
              font-weight: bold;
              letter-spacing: -0.4px;
              text-align: right;
              color: #202431;
            "
          >
            {{ my.staking.total.toFixed(2) | comma }}
          </div>
          <div
            style="
              position: absolute;
              right: 622px;
              top: 100px;
              font-family: Poppins;
              font-size: 24px;
              font-weight: 500;
              letter-spacing: -0.24px;
              text-align: right;
              color: #a5aaba;
            "
          >
            LOKA
          </div>
          <textarea
            placeholder="Please enter your self-introduction."
            @input="onChangeComment($event)"
            v-model="input_comment"
            style="
              width: 400px;
              height: 120px;
              border-radius: 4px;
              border: solid 1px #dfe5ef;
              background-color: #fff;
              padding-left: 20px;
              padding-right: 20px;
              padding-top: 20px;
              position: absolute;
              right: 40px;
              top: 40px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 500;
              line-height: 1.75;
              letter-spacing: -0.4px;
              text-align: left;
              color: #202431;
            "
          />
          <div
            style="
              position: absolute;
              right: 53px;
              bottom: 52px;
              font-family: Poppins;
              font-size: 13px;
              font-weight: 500;
              letter-spacing: -0.13px;
              text-align: right;
              color: #a5aaba;
            "
          >
            0 byte
          </div>
        </div>
        <div
          class="bg_staking_continent_list_2"
          style="position: absolute; left: calc(50% - 640px); top: 310px"
          v-bind:style="{
            height: `${153 + 104 * my_continents.length}px`,
          }"
        >
          <div
            style="
              position: absolute;
              top: 0px;
              left: 30px;
              width: 1220px;
              height: 93px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              padding-top: 45px;
              color: #202431;
            "
          >
            <div style="width: 100px; float: left; height: 100%">Tier</div>
            <div style="width: 300px; float: left; height: 100%">Continent</div>
            <div style="width: 400px; float: left; height: 100%">Pledged</div>
            <div style="width: 420px; float: left; height: 100%">
              Management
            </div>
            <div
              style="
                width: 100%;
                height: 1px;
                border: solid 0 #000;
                background-color: #c5cbd7;
                position: absolute;
                bottom: 0px;
                left: 0px;
              "
            ></div>
          </div>
          <div
            v-for="(continent, idx7) in my_continents"
            :key="idx7"
            style="position: absolute; top: 93px; left: 30px; width: 1220px"
            v-bind:style="{ top: `${93 + 104 * idx7}px` }"
          >
            <div
              style="
                width: 100%;
                height: 104px;
                font-family: Poppins;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: -0.16px;
                text-align: center;
                color: #202431;
              "
            >
              <div
                style="
                  width: 100px;
                  float: left;
                  height: 100%;
                  padding-top: 16px;
                "
              >
                <img
                  v-bind:src="`/img/staking/label-tier-${continent.tier}.png`"
                />
              </div>
              <div style="width: 300px; float: left; height: 100%">
                <div
                  style="
                    margin-top: 16px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 600;
                    letter-spacing: -0.2px;
                    color: #202431;
                  "
                >
                  Continent {{ continent.continent }}
                </div>
                <div
                  style="
                    margin-left: calc(50% - 50px);
                    margin-top: 6px;
                    width: 100px;
                    height: 32px;
                    border-radius: 6px;
                    border: solid 0 #000;
                    background-color: #0060ff;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 500;
                    text-align: left;
                    color: #fff;
                    padding-top: 4px;
                    cursor: pointer;
                  "
                  @click="popContinentRank(continent.continent)"
                >
                  <img
                    src="/img/staking/icon-rank.png"
                    style="margin-left: 10px"
                  />
                  <span style="vertical-align: middle; margin-left: 10px"
                    >Rank</span
                  >
                </div>
              </div>
              <div
                style="
                  padding-right: 100px;
                  width: 400px;
                  float: left;
                  height: 100%;
                  padding-top: 30px;
                  text-align: right;
                "
              >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 24px;
                    font-weight: bold;
                    letter-spacing: -0.24px;
                    text-align: right;
                    color: #202431;
                  "
                  >{{ continent.value.toFixed(2) | comma }}</span
                >
                <span
                  style="
                    font-family: Poppins;
                    font-size: 20px;
                    margin-left: 5px;
                    font-weight: 500;
                    letter-spacing: -0.2px;
                    text-align: right;
                    color: #a5aaba;
                  "
                  >LOKA</span
                >
              </div>
              <div style="width: 420px; float: left; height: 100%">
                <div
                  style="
                    margin-left: 20px;
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #031243;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                    float: left;
                  "
                  @click="popStake(continent.continent)"
                >
                  ADD
                </div>
                <div
                  style="
                    margin-right: 20px;
                    margin-top: 25px;
                    width: 180px;
                    height: 48px;
                    border-radius: 4px;
                    border: solid 0 #000;
                    background-color: #fc6a5b;
                    padding-top: 12px;
                    font-family: Poppins;
                    font-size: 16px;
                    font-weight: 500;
                    text-align: center;
                    color: #fff;
                    cursor: pointer;
                    float: right;
                  "
                  @click="popUnStake(continent.continent)"
                >
                  UNPLEDGE
                </div>
              </div>
              <div
                style="
                  width: 100%;
                  height: 1px;
                  border: solid 0 #000;
                  background-color: #c5cbd7;
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: #00000099;
        cursor: pointer;
        z-index: 900;
      "
      v-if="
        modals.popup_stake == true ||
        modals.popup_unstake == true ||
        modals.continent_rank == true ||
        modals.process_stake == true ||
        modals.process_unstake == true ||
        $store.state.account.modals.approval == true
      "
      @click="closeAllPopup()"
    ></div>
    <div
      v-if="modals.popup_stake"
      style="
        position: fixed;
        top: calc((100% - 580px) / 2);
        left: calc((100% - 600px) / 2);
        text-align: center;
        width: 600px;
        height: 580px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        PLEDGE
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        style="
          position: absolute;
          top: 130px;
          left: 40px;
          width: 520px;
          height: 80px;
          border-radius: 4px;
          border: solid 1px #c6dcff;
          background-color: #edf4ff;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 20px;
        "
      >
        <span
          style="
            font-family: Poppins;
            font-size: 20px;
            font-weight: 500;
            text-align: left;
            color: #202431;
            float: left;
            margin-top: 2px;
          "
        >
          Balance
        </span>
        <span
          style="
            width: 320px;
            float: left;
            font-family: Poppins;
            font-size: 28px;
            font-weight: bold;
            letter-spacing: -0.28px;
            text-align: right;
            color: #202431;
          "
        >
          {{ balance }}
        </span>
        <span
          style="
            font-family: Poppins;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: -0.24px;
            text-align: right;
            color: #a5aaba;
            float: right;
          "
        >
          LOKA
        </span>
      </div>
      <div
        style="
      position: absolute;
      left: 40px;
      top: 280px;
      font-family: Poppins;
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  color: #202431;
}"
      >
        Amount
      </div>
      <input
        type="text"
        v-model="input_price"
        style="
          width: 389px;
          height: 70px;
          border-radius: 4px;
          border: solid 1px #dfe5ef;
          background-color: #fff;
          padding-left: 20px;
          padding-right: 100px;
          text-align: right;
          position: absolute;
          right: 40px;
          top: 260px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: -0.5px;
          color: #202431;
        "
      />
      <div
        style="
          position: absolute;
          right: 68px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          letter-spacing: -0.2px;
          text-align: right;
          color: #a5aaba;
        "
      >
        LOKA
      </div>
      <div
        style="
          position: absolute;
          top: 370px;
          left: calc(50% - 260px);
          width: 520px;
          height: 70px;
          border-radius: 10px;
          border: solid 0 #000;
          background-color: #edf0f6;
          font-family: Poppins;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          color: #969caf;
          padding-top: 12px;
        "
      >
        Please ensure that you typed the desired amount of LOKA correctly,<br />
        before pressing the PLEDGE button.
      </div>
      <div
        style="
          position: absolute;
          bottom: 40px;
          left: calc(50% - 140px);
          width: 280px;
          height: 70px;
          border-radius: 8px;
          border: solid 0 #000;
          background-color: #0a1844;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #fff;
          padding-top: 22px;
          cursor: pointer;
        "
        @click="clickStake()"
      >
        PLEDGE
      </div>
    </div>
    <div
      v-if="modals.popup_unstake"
      style="
        position: fixed;
        top: calc((100% - 580px) / 2);
        left: calc((100% - 600px) / 2);
        text-align: center;
        width: 600px;
        height: 580px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        UNPLEDGE
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        style="
          position: absolute;
          top: 130px;
          left: 40px;
          width: 520px;
          height: 80px;
          border-radius: 4px;
          border: solid 1px #c6dcff;
          background-color: #edf4ff;
          padding-left: 20px;
          padding-right: 20px;
          padding-top: 20px;
        "
      >
        <span
          style="
            font-family: Poppins;
            font-size: 20px;
            font-weight: 500;
            text-align: left;
            color: #202431;
            float: left;
            margin-top: 2px;
          "
        >
          Pledged
        </span>
        <span
          style="
            width: 320px;
            float: left;
            font-family: Poppins;
            font-size: 28px;
            font-weight: bold;
            letter-spacing: -0.28px;
            text-align: right;
            color: #202431;
          "
        >
          {{ staked }}
        </span>
        <span
          style="
            font-family: Poppins;
            font-size: 24px;
            font-weight: 500;
            letter-spacing: -0.24px;
            text-align: right;
            color: #a5aaba;
            float: right;
          "
        >
          LOKA
        </span>
      </div>
      <div
        style="
      position: absolute;
      left: 40px;
      top: 280px;
      font-family: Poppins;
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  color: #202431;
}"
      >
        Amount
      </div>
      <input
        type="text"
        v-model="input_price"
        style="
          width: 389px;
          height: 70px;
          border-radius: 4px;
          border: solid 1px #dfe5ef;
          background-color: #fff;
          padding-left: 20px;
          padding-right: 100px;
          text-align: right;
          position: absolute;
          right: 40px;
          top: 260px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: bold;
          letter-spacing: -0.5px;
          color: #202431;
        "
      />
      <div
        style="
          position: absolute;
          right: 68px;
          top: 280px;
          font-family: Poppins;
          font-size: 20px;
          font-weight: 500;
          letter-spacing: -0.2px;
          text-align: right;
          color: #a5aaba;
        "
      >
        LOKA
      </div>
      <div
        style="
          position: absolute;
          top: 370px;
          left: calc(50% - 260px);
          width: 520px;
          height: 70px;
          border-radius: 10px;
          border: solid 0 #000;
          background-color: #fcd1cd;
          font-family: Poppins;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          color: #f69990;
          padding-top: 12px;
        "
      >
        Please ensure that you typed the desired amount of LOKA correctly,
        <br />
        before pressing the UNPLEDGE button.
      </div>
      <div
        style="
          position: absolute;
          bottom: 40px;
          left: calc(50% - 140px);
          width: 280px;
          height: 70px;
          border-radius: 8px;
          border: solid 0 #000;
          background-color: #fc6a5b;
          font-family: Poppins;
          font-size: 16px;
          font-weight: 500;
          text-align: center;
          color: #fff;
          padding-top: 22px;
          cursor: pointer;
        "
        @click="clickUnstake()"
      >
        UNPLEDGE
      </div>
    </div>
    <div
      v-if="modals.continent_rank"
      style="
        position: fixed;
        top: calc((100% - 1140px) / 2);
        left: calc((100% - 1140px) / 2);
        text-align: center;
        width: 1140px;
        height: 1140px;
        border-radius: 20px;
        border: solid 0 #fff;
        background-color: #fff;
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text"
        style="position: absolute; left: 0px; top: 0px; width: 100%"
      >
        CONTINENT {{ ranking.continent }} > INDIVIDUAL RANK
        <img
          src="/img/staking/icon-close.png"
          style="
            float: right;
            display: inline-block;
            margin-right: 30px;
            cursor: pointer;
          "
          @click="closeAllPopup()"
        />
      </div>
      <div
        class="bg_staking_continent_list_popup"
        style="position: absolute; left: calc(50% - 570px); top: 80px"
      >
        <div
          style="
            position: absolute;
            top: 40px;
            left: 40px;
            width: 1060px;
            height: 70px;
            border-radius: 4px;
            border: solid 0 #000;
            background-color: #edf0f6;
            font-family: Poppins;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: -0.16px;
            text-align: center;
            padding-top: 25px;
            color: #202431;
          "
        >
          <div style="width: 100px; float: left; height: 100%">Rank</div>
          <div style="width: 200px; float: left; height: 100%">Address</div>
          <div style="width: 300px; float: left; height: 100%">
            Total Pledged
          </div>
          <div style="width: 460px; float: left; height: 100%">Comment</div>
        </div>
        <div style="position: absolute; top: 110px; left: 40px; width: 1220px">
          <div
            v-for="(individual, idx5) in ranking.individual"
            :key="idx5"
            style="
              width: 100%;
              height: 84px;
              font-family: Poppins;
              font-size: 16px;
              font-weight: 600;
              letter-spacing: -0.16px;
              text-align: center;
              color: #202431;
            "
          >
            <div
              style="width: 100px; float: left; height: 100%; padding-top: 26px"
            >
              Rank {{ idx5 + 1 }}
            </div>
            <div
              style="
                width: 200px;
                float: left;
                height: 100%;
                padding-top: 26px;
                padding-left: 40px;
              "
            >
              <div class="bg_eth_address">
                {{ showAddress(individual.address) }}
              </div>
            </div>
            <div
              style="
                padding-right: 60px;
                width: 300px;
                float: left;
                height: 100%;
                padding-top: 20px;
                text-align: right;
              "
            >
              <span
                style="
                  font-family: Poppins;
                  font-size: 24px;
                  font-weight: bold;
                  letter-spacing: -0.24px;
                  text-align: right;
                  color: #202431;
                "
                >{{ individual.value.toFixed(2) | comma }}</span
              >
              <span
                style="
                  font-family: Poppins;
                  font-size: 20px;
                  margin-left: 5px;
                  font-weight: 500;
                  letter-spacing: -0.2px;
                  text-align: right;
                  color: #a5aaba;
                "
                >LOKA</span
              >
            </div>
            <div
              v-if="individual.staking != null"
              style="
                width: 460px;
                float: left;
                height: 100%;
                padding-top: 20px;
                padding-left: 50px;
                padding-right: 50px;
                font-family: Poppins;
                font-size: 13px;
                font-weight: 500;
                line-height: 1.54;
                letter-spacing: -0.13px;
              "
            >
              {{ individual.staking.comment }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modals.process_stake"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Pledging processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for staking...<br /><br />
        It may take up to 1-5 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://etherscan.io/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="modals.process_unstake"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Unstaking processing
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 110px;
          width: 90%;
          height: 200px;
        "
      >
        Wait for unstaking...<br /><br />
        It may take up to 1-5 minutes depending on the Ethereum network
        situation.<br /><br />
        Your transaction hash is <br /><a
          v-bind:href="`https://etherscan.io/tx/${tx_id}`"
          target="_blank"
          style="color: #000; text-decoration: underline"
          >{{ tx_id.substring(0, 30) }}<br />{{ tx_id.substring(30) }}</a
        >
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div>
    <div
      v-if="$store.state.account.modals.approval == true"
      style="
        position: fixed;
        top: calc((100% - 640px) / 2);
        left: calc((100% - 560px) / 2);
        padding-top: 32px;
        text-align: center;
        width: 640px;
        height: 560px;
        background-image: url('/img/mydrago/popupbase.png');
        z-index: 10000;
      "
    >
      <div
        class="popup-head-text-2"
        style="position: absolute; left: 0px; top: 20px; width: 100%"
      >
        Need to approve LOKA
      </div>
      <div
        class="popup-content-text"
        style="
          position: absolute;
          left: 5%;
          top: 120px;
          width: 90%;
          height: 200px;
        "
      >
        You should confirm to approve LOKA.<br />
        Please wait for the transaction to complete.<br /><br />
        It may take up to ~3 minutes depending on the Ethereum network
        situation.<br /><br />
        This approval process is required only once.
      </div>
      <div
        id="loading-image"
        style="position: absolute; left: calc(50% - 40px); bottom: 140px"
      ></div>
      <div
        style="
          position: absolute;
          top: 450px;
          left: 0px;
          width: 640px;
          height: 110px;
          border: solid 0 #fff;
          background-color: #e6e7ec;
        "
      >
        <div
          @click="closeAllPopup()"
          class="popup-btn"
          style="position: absolute; left: 180px; top: 20px; cursor: pointer"
        >
          OK
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
import { Parallax } from "@/components";
import config from "../config.js";
import axios from "axios";
import {
  connectWallet,
  checkLoka,
  lokaBalance,
  stakeOf,
  allStakeOf,
  stakeLoka,
  unstakeLoka,
  getNetwork,
  sign
} from "../utils/wallet";
import Button from '../components/Button.vue';

export default {
  name: "staking",
  bodyClass: "staking-page",
  components: {
    Parallax,
  },
  
    Buttoncreated() {},

  mounted: async function () {
    await connectWallet(this.$store);
    this.getStakingDashboard();
  },
  beforeDestroy() {},
  methods: {
    async clickMenu(menu) {
      this.menu = menu;
      switch (this.menu) {
        case 0:
          await this.getStakingDashboard();
          break;
        case 1:
          await this.getStakeList();
          break;
        case 2:
          await this.getMyStaking();
          break;
      }
    },
    async clickStake() {
      let amount = Number(this.input_price);
      console.log(this.selectedContinent, amount, this.balance);
      if (amount == 0) return alert("Please enter the amount of LOK to pledge.");
      if (amount > this.balance)
        return alert("You cannot pledge more than the amount of LOKA you have.");
      await checkLoka(this.$store);
      let self = this;
      stakeLoka(this.$store, this.selectedContinent, amount)
        .on("transactionHash", async (txHash) => {
          self.tx_id = txHash;
          console.log("transactionHash");
          console.log(txHash);
          self.closeAllPopup();
          self.openModal("process_stake");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log("publicKey", self.publicKey);
          console.log("transactionHash", receipt.transactionHash);
          self.closeModal("process_stake");

          if (self.menu == 1) {
            self.clickMenu(2);
          } else if (self.menu == 2) {
            await self.getMyStaking();
          }
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
        });
    },
    async clickUnstake() {
      let amount = Number(this.input_price);
      console.log(this.selectedContinent, amount, this.staked);
      if (amount == 0)
        return alert("Please enter the amount of LOK to unpledge.");
      if (amount > this.staked)
        return alert("You cannot unpledge more than the amount of LOK pledged.");
      let self = this;
      unstakeLoka(this.$store, this.selectedContinent, amount)
        .on("transactionHash", async (txHash) => {
          console.log("transactionHash");
          self.tx_id = txHash;
          console.log(txHash);
          self.closeAllPopup();
          self.openModal("process_unstake");
        })
        .on("receipt", async (receipt) => {
          console.log("receipt");
          console.log("transactionHash", receipt.transactionHash);
          self.closeModal("process_unstake");

          if (self.menu == 2) {
            await self.getMyStaking();
          }
        })
        .on("error", (error) => {
          console.log("error");
          console.log(error);
        });
    },
    async clickClaimMyReward() {
      this.my.reward = null;

      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      var ret = await axios.post(
        `${config.api.game_url}/staking/claim/myreward`,
        { address: address }
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.$store.commit(
          "alert",
          `The reward will be sent to the connected address of the polygon network within 24 hours.`
        );
      }
    },
    clickSubMenu(subMenu) {
      this.sub_menu = subMenu;
    },
    clickTable() {
      this.openModal("table");
    },
    clickLearnMore() {
      let url =
        "//leagueofkingdoms.substack.com/p/lok-community-update-jan223" +
        localStorage.urlParam;
      window.open(url, "_blank");
    },
    async popContinentRank(continent) {
      this.ranking.continent = continent;
      await this.getContinentRanking(continent);
      this.openModal("continent_rank");
    },
    async popStake(continent) {
      if (config.network.eth != (await getNetwork()))
        return alert("Wrong network. Please connect to Ethereum network.");
      this.selectedContinent = continent;
      this.balance = await lokaBalance(this.$store);
      this.input_price = 0;
      this.openModal("popup_stake");
    },
    async popUnStake(continent) {
      if (config.network.eth != (await getNetwork()))
        return alert("Wrong network. Please connect to Ethereum network.");
      this.selectedContinent = continent;
      this.staked = await stakeOf(this.$store, continent);
      this.input_price = 0;
      this.openModal("popup_unstake");
    },
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    closeAllPopup() {
      this.modals.process_stake = false;
      this.modals.process_unstake = false;
      this.modals.continent_rank = false;
      this.modals.table = false;
      this.modals.popup_stake = false;
      this.modals.popup_unstake = false;
      this.$store.commit("closeModal", "approval");
    },
    closeModal(modal) {
      this.modals[modal] = false;
    },
    openModal(modal) {
      this.closeAllPopup();

      this.modals[modal] = true;
    },
    getEggAsset(tokenId) {
      return `${config.api.egg_url}/${tokenId}`;
    },
    getDragoAsset(tokenId) {
      return `${config.api.drago_url}/${tokenId}`;
    },
    getTop(index) {
      return Math.floor(index / 4) * 413 + "px";
    },
    getLeft(index) {
      return (index % 4) * 280 + "px";
    },
    getListHeight() {
      let num = this.myEggs.length + this.myDragos.length;
      let row = Math.floor((num - 1) / 4) + 1;
      if (row <= 2) {
        return "806px";
      }
      return 393 * row + 20 * (row - 1) + "px";
    },
    getTotalHeight() {
      if (this.menu == 0) {
        if (this.sub_menu == 0) {
          let h =
            346 + 2400 - 889 + (153 + 104 * this.dashboard.continents.length);
          return h + "px";
        } else {
          let h =
            346 + 2400 - 889 + (153 + 104 * this.dashboard.individuals.length);
          return h + "px";
        }
      } else if (this.menu == 1) {
        let h = 900 + (153 + 104 * this.stake.continent.length);
        return h + "px";
      } else if (this.menu == 2) {
        let h = 1200 + (153 + 104 * this.my_continents.length);
        return h + "px";
      }
      return "2400px";
    },
    async getStakingDashboard() {
      var ret = await axios.post(
        `${config.api.game_url}/staking/dashboard`,
        {}
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.dashboard.continent = ret.data.dashboard.continent;
        this.dashboard.individual = ret.data.dashboard.individual;
        this.dashboard.totalValue = ret.data.dashboard.totalValue;
        this.dashboard.totalHolder = ret.data.dashboard.totalHolder;
        this.dashboard.continents = [];
        for (let i = 3; i < this.dashboard.continent.length; ++i) {
          this.dashboard.continents.push(this.dashboard.continent[i]);
        }
        this.dashboard.individuals = [];
        for (let i = 3; i < this.dashboard.individual.length; ++i) {
          this.dashboard.individuals.push(this.dashboard.individual[i]);
        }
      }
    },
    async getStakeList() {
      var ret = await axios.post(
        `${config.api.game_url}/staking/stake/list`,
        {}
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.stake.continent = ret.data.stake.continent;
      }
    },
    async getMyStaking() {
      let address = "";
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }

      var ret = await axios.post(`${config.api.game_url}/staking/mystaking`, {
        address: address,
      });
      console.log(ret.data);
      if (ret.data.result) {
        let my = ret.data.my;
        this.input_comment = my.staking.comment;
        let list = await allStakeOf(this.$store, my.continents.length + 1);
        my.staking.total = list[0];
        let continents = [];
        for (let continent of my.continents) {
          continent.value = list[continent.continent];
          if (continent.value > 0) continents.push(continent);
        }
        this.my_continents = continents;
        this.my = my;
      }
    },
    async changeComment(comment) {
      let address = "";
      if(comment.length>30)
        return alert("Comments can contain up to 30 characters.")
      if (
        this.$store.state.account != null &&
        this.$store.state.account.wallet != null
      ) {
        address = this.$store.state.account.wallet.address;
      }
      let signed = await sign(this.$store, comment)
      var ret = await axios.post(
        `${config.api.game_url}/staking/change/comment`,
        { address: address, comment: comment, signed: signed }
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.my.staking.comment = this.input_comment;
      }
    },
    async getContinentRanking(continent) {
      var ret = await axios.post(
        `${config.api.game_url}/staking/continent/ranking`,
        { continent: continent }
      );
      console.log(ret.data);
      if (ret.data.result) {
        this.ranking.individual = ret.data.ranking.individual;
      }
    },
    showAddress(address) {
      return (
        address.substring(0, 5) + "..." + address.substring(address.length - 3)
      );
    },
    submitComment(event){
      this.changeComment(this.input_comment);
    },
    onChangeComment(event) {
      this.changeComment(this.input_comment);
    },
  },
  watch: {
    "$store.state.account.wallet": async function (val) {
      switch (this.menu) {
        case 0:
          await this.getStakingDashboard();
          break;
        case 1:
          await this.getStakeList();
          break;
        case 2:
          await this.getMyStaking();
          break;
      }
    },
  },
  filters: {
    comma(val) {
      return Number(val).toLocaleString("en-US");
      //return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    date(val) {
      if (val) {
        return moment(String(val)).format("YYYY-MM-DD HH:mm:ss");
      }
    },
  },
  data: function () {
    return {
      tx_id: "",
      menu: 0,
      sub_menu: 0,
      input_comment: "",
      modals: {
        popup_stake: false,
        popup_unstake: false,
        continent_rank: false,
        table: false,
        process_stake: false,
        process_unstake: false,
      },
      dashboard: {
        continent: [],
        individual: [],
        continents: [],
        individuals: [],
        totalHolder: 0,
        totalValue: 0,
      },
      stake: {
        continent: [],
      },
      ranking: {
        continent: 1,
        individual: [],
      },
      my: {
        reward: null,
        address: "",
        value: 0,
        ranking: 0,
        continents: [],
        staking: {
          total: 0,
        },
      },
      selectedContinent: 0,
      input_price: 0,
      staked: 0,
      my_continents: [],
      balance: 0,
    };
  },
};
</script>
<style>
.page-header {
  max-height: none !important;
}

.bg_bonus-area {
  width: 100%;
  border: solid 0 #000;
  background-color: #04050d;
}

.LOKA-STAKING-POOLS {
  position: absolute;
  width: 800px;
  height: 100px;
  top: 190px;
  left: calc(50% - 400px);
  background-image: linear-gradient(to right, #523bff, #2cd9bc),
    linear-gradient(to bottom, #24f9c5, #24f9c5);
  font-size: 60px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: -1.8px;
  text-align: center;
  color: #24f9c5;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.LOKA-STAKING-POOLS-DESC {
  position: absolute;
  width: 800px;
  height: 60px;
  top: 290px;
  left: calc(50% - 400px);
  font-size: 20px;
  font-family: Poppins;
  font-size: 20px;
  line-height: 1.6;
  text-align: center;
  color: #fff;
}

.staking_tab {
  width: 200px;
  height: 100%;
  padding-top: 25px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  display: inline-block;
  cursor: pointer;
}

.staking_tab.on {
  color: #16ffda;
}

.staking_main_tab {
  cursor: pointer;
  width: 292px;
  height: 48px;
  padding-top: 12px;
  font-family: Poppins;
  font-family: Poppins;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: #fff;
  display: inline-block;
}

.staking_main_tab.on {
  border-radius: 24px;
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.2);
  border: solid 0 #000;
  background-color: #06f;
}

.staking_tab_bar {
  position: absolute;
  bottom: 0px;
  width: 200px;
  height: 4px;
  border: solid 0 #000;
  background-color: #15ffd9;
}

.bg_staking_main {
  width: 1440px;
  height: 1539px;
  border: solid 0 #000;
  background-color: #1b1f34;
}

.bg_staking_stake {
  width: 1440px;
  height: 1434px;
  border: solid 0 #000;
  background-color: #1b1f34;
}

.bg_card_staking_continent {
  width: 416px;
  height: 440px;
  border-radius: 16px;
  box-shadow: 0px 10px 10px 0 rgba(0, 6, 37, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.bg_card_staking_continent_2 {
  width: 416px;
  height: 400px;
  border-radius: 16px;
  box-shadow: 0px 10px 10px 0 rgba(0, 6, 37, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.bg_staking_continent_list {
  width: 1280px;
  height: 889px;
  border-radius: 16px;
  box-shadow: 0px 10px 10px 0 rgba(0, 6, 37, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.bg_staking_continent_list_2 {
  width: 1280px;
  height: 1274px;
  border-radius: 16px;
  box-shadow: 0px 10px 10px 0 rgba(0, 6, 37, 0.2);
  border: solid 0 #000;
  background-color: #fff;
}

.bg_staking_continent_list_popup {
  width: 1140px;
  height: 910px;
}

.bg_eth_address {
  width: 120px;
  height: 32px;
  border-radius: 16px;
  border: solid 1px #c6dcff;
  background-color: #edf4ff;
  font-family: Poppins;
  font-size: 14px;
  text-align: center;
  color: #6673a0;
  padding-top: 5px;
}

.card-drago {
  width: 260px;
  height: 393px;
  border-radius: 4px;
  background-color: #fff;
}

.card-drago-top {
  width: 260px;
  height: 260px;
  border: solid 0 #000;
  background-color: #e6e7ec;
  position: absolute;
  top: 0px;
  left: 0px;
}

.card-drago-bottom {
  width: 260px;
  height: 133px;
  position: absolute;
  top: 260px;
  left: 0px;
}

.card-name-text {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #202431;
}

.card-tokenid-text {
  font-family: Poppins;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #202431;
}

.btn-hatching {
  width: 220px;
  height: 60px;
  border: solid 0 #000;
  background-color: #3920d7;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding-top: 20px;
  cursor: pointer;
}

.btn-disable {
  width: 220px;
  height: 60px;
  border: solid 0 #000;
  background-color: #c0c5d5;
  font-family: Poppins;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding-top: 20px;
}

.popup-head-text {
  width: 1140px;
  height: 80px;
  box-shadow: 0px -6px 6px 0 rgba(0, 0, 0, 0.1);
  border: solid 0 #000;
  background-color: #4613eb;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  text-align: left;
  color: #fff;
  padding-top: 24px;
  padding-left: 40px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.popup-head-text-2 {
  width: 1140px;
  height: 80px;
  font-family: Poppins;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.33;
  text-align: left;
  color: #fff;
  padding-top: 0px;
  padding-left: 40px;
}

.popup-btn {
  width: 280px;
  height: 70px;
  border-radius: 2px;
  border: solid 0 #000;
  background-color: #0a1844;
  font-family: Poppins;
  padding-top: 22px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

#loading-image {
  height: 80px;
  width: 80px;
  background: url("/img/genesis/loading.png") 0px 0px;
  animation: play 0.8s steps(8) infinite;
}
@keyframes play {
  100% {
    background-position: -640px;
  }
}

.bg-empty-list {
  width: 80px;
  height: 80px;
  padding: 19px 14px 20px;
  border-radius: 40px;
  border: solid 0 #000;
  background-color: #202431;
}
</style>
